import React from 'react';
import { connectStats } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

const FiltersHeader = ({ nbHits }) => {
    const paginationLimit = Number(process.env.ALGOLIA_PAGINATION_LIMIT);
    const totalCount = nbHits > paginationLimit ? paginationLimit : nbHits;
    const totalCountText = totalCount.toLocaleString('en') + (nbHits > paginationLimit ? '+' : '');

    return <h3 className="card-title mt-1 mb-3 ml-0 mx-0 pt-0 display6 bold">Filter Results ({totalCountText})</h3>;
};

FiltersHeader.propTypes = {
    nbHits: PropTypes.number.isRequired,
};

export default connectStats(FiltersHeader);
